import React, { useState, useEffect } from 'react';
import { LoadEffect, TableLoader } from '../component/loader';
import axios from 'axios';
import PageHeader from '../component/pageheader';
import { config, API_URL } from '../component/include';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
// Using standard HTML date inputs instead of react-datepicker
import Error403 from '../settings/error403';
import HomeworkPreview from './HomeworkPreview';
import HomeworkReports from './HomeworkReports';
import { formatGroupLabel, getClassArm, getClassName} from '../component/globalFunction'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { Alerts, WarningModal } from '../component/notify';


const Homework = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  const [showReportsModal, setShowReportsModal] = useState(false);
  const [homeworkList, setHomeworkList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [activeList, setActiveList] = useState();
 const schoolClass  = useSelector(state => state.rootReducer.schoolClass);

 const [homework, setHomework] = useState({
  showPreviewModal:false,
  showReportsModal:false,
  code:'',
  className:'',
  student_code:'',
  homework_date:'',
  selectedHomework:''
});

  const [filters, setFilters] = useState({
    studentClass:[],
    subject:[],
    student_name: '',
    admission_number: '',

    start_date: null,
    end_date: null
  });


  const [notice, setNotice] = useState({
    isLoading: false,
    isError: false,
    message: ''
  });
  const [errors, setErrors] = useState({
    successMessage: '',
    errorMessage: ''
  });




  const { SearchBar } = Search;

 
  const handleSelect = (option, action)=>{
    setFilters({...filters, [action.name]: option });

  }

 
  const fetchHomeworkList = async () => {
    setNotice({ ...notice, isLoading: true });
    try {
const fd = new FormData();
fd.append('sectionID', filters.studentClass.value);
fd.append('start_date', filters.start_date ? formatDate(filters.start_date) : '');
fd.append('end_date', filters.end_date ? formatDate(filters.end_date) : '');

  const response = await axios.get(`${API_URL}/homework/display/all`, fd, config);
      console.log(response.data.data)
      if ( Array.isArray(response.data.data) && response.data.data.length > 0) {

        //loop through the data and add a new column called completion_status
        response.data.data.forEach(element => {
         //random unique 8 digit string
         element.code = Math.random().toString(36).substring(2, 10);
          
          element.className = getClassName(element.classID, element.sectionID, schoolClass)
              });
        setHomeworkList(response.data.data);
        window.scrollTo(0, document.body.scrollHeight);
        setNotice({ isLoading: false, isError: false, message: '' });
        setStudentList([]);
      } else {
        setHomeworkList([]);
        setStudentList([]);
        setNotice({ isLoading: false, isError: true, message: 'No record found' });
      }
    } catch (error) {
      setNotice({ isLoading: false, isError: true, message: 'Error fetching homework list' });
    }
  };


  
  const fetchStudentList = async (row) => {
    setNotice({ ...notice, isLoading: true });
    setActiveList(row);
    try {

  const response = await axios.get(`${API_URL}/homework/student_list/${row.homework_code}`, config);
      
      if (Array.isArray(response.data.data) && response.data.status === 200) {

        response.data.data.forEach(element => {
          //random unique 8 digit string
          element.code = Math.random().toString(36).substring(2, 10);
           
           element.className = getClassName(element.classID, element.sectionID, schoolClass)
               });

        setStudentList(response.data.data);

        //scroll to end
        window.scrollTo(0, document.body.scrollHeight);
        setNotice({ isLoading: false, isError: false, message: '' });
      } else {
        setStudentList([]);
        setNotice({ isLoading: false, isError: true, message: 'No record found' });
      }
    } catch (error) {
      setStudentList([]);
      setNotice({ isLoading: false, isError: true, message: 'Error fetching student list' });
    }
  };





  const handleDateChange = (e, field) => {
    setFilters({ ...filters, [field]: e.target.value });
  };

  const applyFilters = () => {
    fetchHomeworkList();
  };

  const resetFilters = () => {
    setHomeworkList([]);
        setStudentList([]);
    setFilters({
      class_id: '',
      student_id: '',
      admission_number: '',
      subject_id: '',
      start_date: null,
      end_date: null
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    // HTML date inputs already use YYYY-MM-DD format, so we can use it directly
    return dateString;
  };

  const displayDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
  };

  const handleCreateHomework = () => {
   window.open('/homework/create', '_self');
  };

  const handlePreviewHomework = (row) => {
    // Navigate to the homework preview page with state
    window.open(`/homework/preview/${row.homework_code}/${row.student_code}`, '_blank');
  };



  const handleDelete = async (code) => {
    let close =   document.getElementById('btnWarningDialog-'+code)
    close.click();
      setNotice({ ...notice, isLoading: true });
      try {
        const response = await axios.get(`${API_URL}/homework/delete/${code}`, config);
        
        if (response.data.status === 200) {
          setErrors({
            successMessage: 'Homework deleted successfully',
            errorMessage: ''
          });
          fetchHomeworkList();
          setStudentList([])
        } else {
          setErrors({
            successMessage: '',
            errorMessage: 'Failed to delete homework'
          });
        }
        setNotice({ ...notice, isLoading: false });
      } catch (error) {
        setErrors({
          successMessage: '',
          errorMessage: 'Error deleting homework'
        });
        setNotice({ ...notice, isLoading: false });
      }
  };

  const actionFormatter = (cell, row) => {
    return (
      <div className="d-flex">

<WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDelete(row.homework_code)} mID={row.homework_code} /> 
        <button 
          type="button"
          className="btn btn-info btn-sm mr-2" 
          onClick={() =>fetchStudentList(row)}
        >
          <i className="fa fa-eye"></i> View
        </button>

        <a href="#!" data-toggle="modal"   data-target={`#warningdialog-${row.homework_code}`} className="btn btn-danger btn-sm"     title="Delete">
          
        <i className="fa fa-trash"></i> Delete
        
        </a>


      </div>
    );
  };


  const handleDeleteSome = async (homework_code, student_code) => {


    let close =   document.getElementById('btnWarningDialog-'+student_code)
              close.click();


    setNotice({ ...notice, isLoading: true });
    try {
      const response = await axios.get(`${API_URL}/homework/delete_some/${homework_code}/${student_code}`, config);
      
      if (response.data.status === 200) {
        setErrors({
          successMessage: 'Homework deleted successfully',
          errorMessage: ''
        });
        fetchHomeworkList();
        setStudentList([])
      } else {
        setErrors({
          successMessage: '',
          errorMessage: 'Failed to delete homework'
        });
      }
      setNotice({ ...notice, isLoading: false });
    } catch (error) {
      setErrors({
        successMessage: '',
        errorMessage: 'Error deleting homework'
      });
      setNotice({ ...notice, isLoading: false });
    }
};


  const columns = [
    {
      dataField: 'id',
      text: 'SN',
      formatter: (cell, row, index) => index + 1,
    },
    {
      dataField: 'className',
      text: 'Class',
      sort: true
    },
    {
      dataField: 'homework_date',
      text: 'Homework Date',
      formatter: (cell) => displayDate(cell),
      sort: true
    },
    {
      dataField: 'default_return_date',
      text: 'Return Date',
      formatter: (cell) => displayDate(cell),
      sort: true
    },
    {
      dataField: 'staffName',
      text: 'Created By',
      sort: true
    },
    
    {
      dataField: 'completion_status',
      text: 'Completion',
      formatter: (cell, row) => {
        // Use completion_status to calculate percentage
    const percentage = (Number(row.completed) / Number(row.total)) * 100;

        return (
          <div className="progress" style={{ height: '20px', backgroundColor: '#000000' }}>
            <div 
              className="progress-bar" 
              style={{ 
                width: `${percentage}%`,
                backgroundColor:  percentage <= 10 ? ' #dc3545':percentage <=50 ? '#dc3174' : percentage <= 80 ? ' #ffc107' : '#28a745',
                color: '#fff',
                textAlign: 'center',
                fontSize: '14px',
                fontWeight: 'bold',
                lineHeight: '20px'
              }} 
              role="progressbar" 
              aria-valuenow={percentage.toFixed(2)} 
              aria-valuemin="0" 
              aria-valuemax="100"
            >
              {percentage.toFixed(2)}%
            </div>
          </div>
        );
      }
    },
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: actionFormatter
    }
  ];


  const columnStudent = [
    {
      dataField: 'id',
      text: 'SN',
      formatter: (cell, row, index) => index + 1,
    },
    {
      dataField: 'studentName',
      text: 'Student Name',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.studentName+ ' (' + row.admissionNumber + ')' }</div>,
      sort: true
    },
    {
      dataField: 'behavior_comments',
      text: 'Behavior Comments',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.behavior_comments}</div>,
      sort: true
    },
    {
      dataField: 'teacher_remarks',
      text: 'Teacher Remarks',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.teacher_remarks}</div>,
      sort: true
    },
    {
      dataField: 'parent_response',
      text: 'Parent Response',
      formatter: (cell, row) => <div style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', width: '200px'}}>{row.parent_response}</div>,
      sort: true
    },
    
    {
      dataField: 'completion_status',
      text: 'Completion',
      formatter: (cell, row) => {
        // Use completion_status to calculate percentage
  
        const percentage = (Number(row.completed) / Number(row.total)) * 100;

        return (
          <div className="progress" style={{ height: '20px', backgroundColor: '#000000' }}>
          <div 
            className="progress-bar" 
            style={{ 
              width: `${percentage}%`,
              backgroundColor:  percentage <= 10 ? ' #dc3545':percentage <=50 ? '#dc3174' : percentage <= 80 ? ' #ffc107' : '#28a745',
              color: '#fff',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              lineHeight: '20px'
            }} 
            role="progressbar" 
            aria-valuenow={percentage.toFixed(2)} 
            aria-valuemin="0" 
            aria-valuemax="100"
          >
            {percentage.toFixed(2)}%
          </div>
        </div>
        );
      }
    },
    {
      dataField: 'actions',
      text: 'Actions',
      formatter: (cell, row) => {
        return (
          <div className="d-flex">

<WarningModal message="This is very dangerous, you shouldn't do it! are you really really sure.?" handleAction={()=>handleDeleteSome(row.homework_code, row.student_code)} mID={row.student_code} /> 

            <button 
              type="button"
              className="btn btn-info btn-sm mr-2" 
              onClick={() => handlePreviewHomework(row)}
            >
              <i className="fa fa-eye"></i> View
            </button>

            <a href="#!" data-toggle="modal"   data-target={`#warningdialog-${row.student_code}`} className="btn btn-danger btn-sm"     title="Delete">
          
        <i className="fa fa-trash"></i> Delete
        
        </a>

          </div>
        );
      }
    }
  ];

  const paginationOptions = {
    sizePerPage: 100,
    sizePerPageList: [100, 250, 500, 1000],
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
  };



  return (
    <>
      <div className="main-body">
        {isAuthenticated ? (
          <div className="page-wrapper">
            {notice.isLoading && <LoadEffect className="overlay floatLoad" />}
            
            <PageHeader title="Homework Management">
              <li className="breadcrumb-item">
                <a href="#!"><i className="fa fa-fw fa-book"></i></a>
              </li>
              <li className="breadcrumb-item">
                <a href="#!">Academic</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#!">Homework</a>
              </li>
            </PageHeader>

            <div className="page-body">
          
            {errors.errorMessage && (
                <div className="alert alert-danger background-danger">
                  <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <i className="fa fa-times text-white"></i>
                  </button>
                  <strong>{errors.errorMessage}</strong>
                </div>
              )}
      

      {errors.successMessage && (
                <div className="alert alert-success background-success">
                  <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <i className="fa fa-times text-white"></i>
                  </button>
                  <strong>{errors.successMessage}</strong>
                </div>
              )}


              {notice.message && (
                <div className="alert alert-danger background-danger">
                  <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                    <i className="fa fa-times text-white"></i>
                  </button>
                  <strong>{notice.message}</strong>
                </div>
              )}

              <div className="row">
                <div className="col-sm-12">
                  <div className="card z-depth-0">
                    <div className="card-header">
                      <h5><i className="fa fa-filter"></i> Filter Homework</h5>
                      <div className="card-header-right">
                        <ul className="list-unstyled card-option">
                          <li><i className="feather icon-maximize full-card"></i></li>
                          <li><i className="feather icon-minus minimize-card"></i></li>
                          <li><i className="feather icon-trash-2 close-card"></i></li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-block">
                      <div className="row">


                        <div className="col-md-6 form-group">
                          
                     

                        <div className="form-group">
         <label> Student Class<span style={{color:'red'}}>*</span></label>
        <Select  options={
                              schoolClass.map((list, idx)=> {
                                return {key:idx, classtype:list.arms, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                    return sec.sname !==''? {key:id, classID:list.ID, classtype:list.arms, isSection:'1', value: sec.ID, label: sec.sname}:{key:id, classtype:list.arms, classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                                }) }
                              })
							 
                        } 
                        formatGroupLabel={formatGroupLabel}
onChange={handleSelect}  className={errors.studentClass ? 'form-control form-control-danger' : ''} name="studentClass" value={filters.studentClass} id='sessionId' /> 
<span style={{color:'red'}}>{errors.studentClass && errors.studentClass}</span>

            </div>   

            </div>


                      
       
                        <div className="col-md-6 form-group">
                          <label>Homework Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={filters.start_date || ''}
                            onChange={(e) => handleDateChange(e, 'start_date')}
                          />
                        </div>


                        </div>

                        <div className="row">
                        <div className="col-md-6 form-group">
                          <label>Default Return Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={filters.end_date || ''}
                            onChange={(e) => handleDateChange(e, 'end_date')}
                            min={filters.start_date || ''}
                          />
                        </div>
                        <div className="col-md-6 form-group d-flex align-items-end">
                          <button 
                            className="btn btn-primary mr-2" 
                            onClick={applyFilters}
                          >
                            <i className="fa fa-search"></i> Search
                          </button>
                          <button 
                            className="btn btn-secondary" 
                            onClick={resetFilters}
                          >
                            <i className="fa fa-refresh"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {homeworkList.length > 0 && (
              <div className="row mt-4">
                <div className="col-sm-12">
                  <div className="card z-depth-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5><i className="fa fa-book"></i> Homework List</h5>
                      <div>
                        <button 
                          className="btn btn-primary btn-sm mr-2" 
                          onClick={handleCreateHomework}
                        >
                          <i className="fa fa-plus"></i> Create New Homework
                        </button>
                      </div>
                    </div>
                    <div className="card-block table-responsive">
                      <ToolkitProvider
                        keyField="code"
                        data={homeworkList}
                        columns={columns}
                        search
                      >
                        {props => (
                          <div>
                            <div className="row mb-3">
                              <div className="col-md-6 w-full">
                                <SearchBar {...props.searchProps} placeholder="Search homework..." />
                              </div>
                            </div>
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(paginationOptions)}
                              noDataIndication={() => (
                                <div className="text-center">
                                  {notice.isLoading ? (
                                    <TableLoader />
                                  ) : (
                                    <p>No homework records found</p>
                                  )}
                                </div>
                              )}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>
              </div>)}







{studentList.length > 0 && (
              <div className="row mt-4">
                <div className="col-sm-12">
                  <div className="card z-depth-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className='font-weight-bold'><i className="fa fa-book"></i>  {activeList.className+' '+activeList.homework_date+' -'+activeList.default_return_date+ ' By: '+activeList.staffName}</h5>
                     
                    </div>
             {/*        "Make component from here responsive" */}


                    <div className="card-block ">



                      <ToolkitProvider
                        keyField="code"
                        data={studentList}
                        columns={columnStudent}
                        search
                      >
                        {props => (
                          <div className="table-responsive">
                            <div className="row mb-3">
                              <div className="col-md-6 w-full">
                                <SearchBar {...props.searchProps} placeholder="Search homework..." />
                              </div>
                            </div>
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(paginationOptions)}
                              noDataIndication={() => (
                                <div className="text-center">
                                  {notice.isLoading ? (
                                    <TableLoader />
                                  ) : (
                                    <p>No student records found</p>
                                  )}
                                </div>
                              )}
                              striped
                              hover
                              condensed
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>
              </div>
            )}
            </div>

          </div>
        ) : (
          <Error403 />
        )}
      </div>
    </>
  );
};

export default React.memo(Homework);
